import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { useEffect, useContext } from "react";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import { connection } from "./apiConnection.ts";

export default function WithPageTitle({ children }) {
  const auth = useContext(AuthenticationContext);
  const { pathname: currentPath } = useLocation();

  useEffect(() => {
    let date = new Date();
    connection("Insert_Visits", {
      uid: auth.userInfo.id || 0,
      mtm: Math.floor(date.getTime() / 1000),
      path: currentPath,
      user_token: auth.userInfo.token,
    });
  });

  return (
    <>
      <Helmet>
        <title> تات کلاب </title>
        <description> Service base shop website. </description>
      </Helmet>
      {children}
    </>
  );
}
